import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import config from "./config";
export var getStates = function getStates() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("api/states", {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
export var getCountries = function getCountries() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.get("api/countries", {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
export var getEthnicities = function getEthnicities() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.get("api/ethnicities", {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
export var getDocumentTypes = function getDocumentTypes() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios.get("api/documentTypes", {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response.data.map(function (x) {
              return {
                id: x.id,
                name: x.type
              };
            }));
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};
export var getIndications = function getIndications(testCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.get("api/indications?testCode=".concat(testCode), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};